/* eslint-disable camelcase */
import { toast } from 'react-toastify';
import { type UseMutationResult, useMutation, useQueryClient } from 'react-query';
import ToastComponent from '../../components/toast';
import { OptionExerciseService, Wealthlane_AwardService_Dtos_Response_ResponseDto } from '@wealthlane/api-services/wealthlane-award-service';

const usePostExerciseListSingleCalculateTax = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseMutationResult<
  Wealthlane_AwardService_Dtos_Response_ResponseDto | undefined,
  unknown,
  any,
  unknown
> => {
  const queryClient = useQueryClient();
  return useMutation(
    async (payload: any) => {
      return await handleRequest(
        OptionExerciseService.postApiAwardApiAppOptionExerciseCalculateOptionExerciseTaxForSingleRecord(
          payload
        )
      );
    },
    {
      onSuccess: async (response: any) => {
        if (response != null) {
          await Promise.all([
            queryClient.invalidateQueries('getOptionExerciseTaxDetail'),
            queryClient.invalidateQueries('getTransactionHistoryTaxDetail'),
          ]);
          toast.success(<ToastComponent label='Success' message='Tax Calculated' />);
        }
      },
      onError: (err) => {
        console.log('error', err);
      },
    }
  );
};

export default usePostExerciseListSingleCalculateTax;
